import { orderModule } from "../orders/module";
import DateForm from "./orders/Date";
import OrdersForm from "./orders/form";

export const homologarOrderModule = {
  ...orderModule,
  MedicineForm: OrdersForm,
  DateForm,
};
